module.exports = __webpack_public_path__ + "assets/img/30.fw.aeb905c9.png";